import { Radio } from "@jugl-web/ui-components/cross-platform";
import { cx } from "@jugl-web/utils";
import React from "react";

const PhoneMethodRadio: React.FC<{
  checked: boolean;
  title: string;
  onChange: () => void;
}> = ({ checked, title, onChange }) => (
  <label className="font-secondary flex cursor-pointer items-center gap-1">
    <Radio
      isChecked={checked}
      onChange={onChange}
      className="checked:bg-[#3366FF] checked:hover:bg-[#3366FF] checked:focus:bg-[#3366FF]"
    />
    <span
      className={cx(
        "text-grey-700 text-sm leading-[130%]",
        checked && "text-primary-800"
      )}
    >
      {title}
    </span>
  </label>
);

export default PhoneMethodRadio;
